/**
 * タッチデバイス判定ユーティリティ (issue #125)。
 *
 * タブレット (iPad 等) は画面幅が広く width ベース判定 (innerWidth < 768) では
 * Desktop 扱いになってしまう。 タッチ操作可能なデバイスかどうかを別途判定し、
 * Mobile UI を出し分けるために使う。
 *
 * SSR / 非ブラウザ環境では navigator / window が無いので false を返す (safe)。
 */
export function isTouchDevice(): boolean {
  if (typeof navigator !== 'undefined'
      && typeof navigator.maxTouchPoints === 'number'
      && navigator.maxTouchPoints > 0) {
    return true;
  }
  if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
    // 一部テストは matchMedia を差し替え、 未対応クエリに undefined を返すため optional chaining で保護。
    if (window.matchMedia('(pointer: coarse)')?.matches) {
      return true;
    }
  }
  return false;
}

/**
 * 「重いPDF」判定の閾値 (issue #179)。
 *
 * サムネイル描画は pdf.js が元画像を native 解像度でデコードするため、多ページ・大サイズ・
 * 高DPI画像の PDF では瞬間メモリピークが端末上限を超えクラッシュしうる (#176 参照)。
 * 描画前に安価な指標 (blob.size / numPages) だけで検知し、サムネを描かず番号入力
 * フォールバックへ切り替えるための境界値。実クラッシュ例 (7ページ・11.2MB) を捕捉できるよう
 * サイズは 6MiB に設定する。
 */
export const HEAVY_PDF_SIZE_BYTES = 6 * 1024 * 1024; // 6 MiB
export const HEAVY_PDF_PAGE_COUNT = 15;

/**
 * PDF がサムネ描画でメモリ枯渇クラッシュしうる「重いPDF」かを判定する (issue #179)。
 * ファイルサイズ・ページ数のいずれかが閾値以上なら重いとみなす (境界は inclusive)。
 */
export function isHeavyPdf(sizeBytes: number, pageCount: number): boolean {
  return sizeBytes >= HEAVY_PDF_SIZE_BYTES || pageCount >= HEAVY_PDF_PAGE_COUNT;
}
